import { supabase } from '../supabase/client.js';

const REQUESTS_TABLE = 'vim_pay_payment_requests';

function unavailable(error) {
  const code = String(error?.code || '').toUpperCase();
  const message = String(error?.message || '');
  return code === '42P01'
    || code === 'PGRST205'
    || code === 'PGRST202'
    || /vim_pay_payment_requests|vim_pay_submit_payment_request/i.test(message) && /does not exist|could not find|schema cache/i.test(message);
}

export async function listMyPaymentRequests() {
  if (!supabase) return { configured: false, requests: [] };

  const { data, error } = await supabase
    .from(REQUESTS_TABLE)
    .select(`
      id,
      assignment_id,
      project_id,
      worker_id,
      requested_units,
      rate_amount_snapshot,
      rate_unit_snapshot,
      base_amount,
      request_note,
      engagement_type_snapshot,
      union_status_snapshot,
      fringe_profile_key_snapshot,
      rate_validation_status_snapshot,
      tax_status_snapshot,
      status,
      submitted_at,
      production_reviewed_at,
      finance_reviewed_at,
      ready_for_payment_at,
      payroll_fringe_calculated_at,
      assignment:vim_pay_project_assignments(id,role_name,department,authorized_units,status),
      project:vim_pay_projects(id,name,code,production_type,status),
      approvals:vim_pay_payment_approvals(id,stage,decision,review_note,reviewed_at)
    `)
    .order('submitted_at', { ascending: false });

  if (error) {
    if (unavailable(error)) return { configured: false, requests: [] };
    throw error;
  }
  return { configured: true, requests: Array.isArray(data) ? data : [] };
}

export async function submitMyPaymentRequest({ assignmentId, requestedUnits, note }) {
  if (!supabase) throw new Error('VIM Pay is not configured.');
  const units = Number(requestedUnits);
  if (!assignmentId) throw new Error('Choose a project assignment.');
  if (!Number.isFinite(units) || units <= 0) throw new Error('Enter actual units greater than zero.');

  const { data, error } = await supabase.rpc('vim_pay_submit_payment_request', {
    p_assignment_id: assignmentId,
    p_requested_units: units,
    p_note: String(note || '').trim() || null,
  });
  if (error) throw error;
  return data;
}

export function reservedUnitsForAssignment(requests, assignmentId) {
  const reservedStatuses = new Set([
    'submitted',
    'production_approved',
    'ready_for_payment',
    'payroll_rules_hold',
    'payroll_fringe_calculated',
    'payroll_tax_calculated',
  ]);
  return (Array.isArray(requests) ? requests : [])
    .filter((request) => request.assignment_id === assignmentId && reservedStatuses.has(request.status))
    .reduce((sum, request) => sum + Number(request.requested_units || 0), 0);
}
